import React from "react";
import { getRandomString } from '../../utils/utils';

const Use = ({ id, x, y }) => <use xlinkHref={`#${id}`} transform={`translate(${y},${x})`} />;

const BarSvg = ({ stops, width, height, x, y, isBarChart, inversed, key }) => {
  const id = getRandomString();
  const pathId = getRandomString();
  // if (typeof stops === "string") {
  //   return (
  //     <svg key={id} width={width || "100%"} height={height || "50px"}>
  //         <defs>
  //             <g id={`${id}id`}>
  //               <rect
  //                 width={width}
  //                 height={height || "50"}
  //                 rx="10"
  //                 ry="10"
  //                 fill={stops}
  //               />
  //             </g>
  //         </defs>
  //         <Use id={`${id}id`} y={y} x={x} />
  //       </svg>
  //   );
  // }

  const clipPathDef = duration => {
    return (
      <defs>
          <clipPath id={pathId}>
              <rect x="0" y="0" width={duration} height={duration + 9} rx="10" ry="10"/>
          </clipPath>
      </defs>
    )
  }

  const linearGradient = () => (
      <defs>
          <linearGradient id={id} x1="0" y1="0" x2="0%" y2="100%">
            {stops.map(s => (
              <stop
                offset={s.offset}
                stopColor={s.stopColor}
                stopOpacity={s.stopOpacity || 1}
              />
            ))}
          </linearGradient>
        </defs>
  );

    const rect = () => {
      if (isBarChart) {
        return (
          <rect
            x="0"
            y="0"
            width={width}
            height={width}
            clip-path={isBarChart ? `url(#${pathId})`: ''}
            fill={typeof(stops) !== "string" ? `url(#${id})`: stops}
        />
        )
      }
      return (
        <rect
            x="0"
            y="0"
            width={width}
            height={height || "40"}
            rx="10"
            ry="10"
            fill={typeof(stops) !== "string" ? `url(#${id})`: stops}
        />
      )
    }

    return (  
        <svg key={key} width={width || "100%"} height={isBarChart ? width : (height || '40px')} style={inversed ? {transform: 'rotate(180deg)'}: {}}>
            { typeof(stops) !== "string" && linearGradient() }
            { isBarChart && clipPathDef(width)}

            <defs>
                <g id={`${id}id`}>
                    {rect()}
                </g>
            </defs>
            <Use id={`${id}id`} y={y} x={x} />
        </svg>
    );
};

export default BarSvg;
